import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { TipoGastosService } from '../../tipo-gastos/tipo-gastos.service';
import { GastosService } from '../gastos.service';
import { TipoGastosCreateComponent } from '../../tipo-gastos/tipo-gastos-create/tipo-gastos-create.component';

@Component({
  selector: 'app-gastos-create',
  templateUrl: './gastos-create.component.html',
  styleUrls: ['./gastos-create.component.scss']
})
export class GastosCreateComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  select_Tgastos :Array<any> = [];
  selected!:number;
  constructor(
    public formBuilder: FormBuilder,
    private loading: LoadingService,
    private alerts: AlertService,
    public activeModal: NgbActiveModal,
    public formatter: FormatterService,
    public service: GastosService,
    public _service: TipoGastosService,
    private modalService: NgbModal

  ) { }
  ngOnInit(): void {
    this.select()
    this.form = this.formBuilder.group({
      fecha: ['', Validators.required],
      monto: ['', Validators.required],
      detalle: [''],
      tipo_gasto_id: ['', Validators.required]
    })

    this.form.patchValue({ fecha: new Date().toISOString().substring(0, 10) });
  }

  crearTipoGasto(){
    const modalRef = this.modalService.open(TipoGastosCreateComponent,{ size: 'lg', scrollable: true });
    modalRef.result.then((result: any) => {
      this.select(true);
    }, (reason: any) => {});
  }

  guardar() {
    if (this.form.valid) {
      this.loading.show()
      this.service.create(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert(res.response, "success");
        }, error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro", "danger");
          console.log(err.error.response)
          if (err.error.response) {
            this.alerts.addAlert(err.error.response, "danger");
          }
        }
      })

    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }

  }

  select(asignarUltimo: boolean = false) {
    this.loading.show()
    let user = JSON.parse(localStorage.getItem('usuario') as string);
    this._service.select(user).subscribe({
      next: (res) => {
        this.loading.hide();
        this.select_Tgastos = res;
        if (asignarUltimo && this.select_Tgastos.length > 0) this.form.patchValue({ tipo_gasto_id: this.select_Tgastos[this.select_Tgastos.length-1].id});
      }, error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo Cargar Tipos de gastos de la empresa", "danger");
        console.log(err.error.response)
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    })
  }


}
